import { Location } from 'history';

import { INFO_FULL_PATH } from 'routes/constants';

export const getNextLocation = (location: Location): Location => {
  const params = new URLSearchParams(location.search);

  params.delete('skip_select_user');
  params.delete('agent_uuid');
  const search = params.toString();

  return {
    ...location,
    pathname: INFO_FULL_PATH,
    search: `?${search}`,
  };
};
